import { render, staticRenderFns } from "./MiscSettings.vue?vue&type=template&id=641265a6"
import script from "./MiscSettings.vue?vue&type=script&lang=ts"
export * from "./MiscSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports